import { useLayout, usePageData } from "../../../_metronic/layout/core";
import React from "react";
import clsx from "clsx";
import { PageToolbarButton } from "./PageToolbarButton";
import { ToolbarPageTitle } from "./ToolbarPageTitle";

export const Toolbar: React.FC = () => {
    const { classes } = useLayout();
    const { pageToolbarButtons, rightPageCustomComponent } = usePageData();
    return (
        <div className="toolbar" id="kt_toolbar">
            <div
                id="kt_toolbar_container"
                className={clsx(classes.toolbarContainer.join(" "), "d-flex flex-stack")}
            >
                <ToolbarPageTitle />

                {/* begin::Actions */}
                <div className="d-flex align-items-center py-1">
                    <div className="me-4 toolbar-buttons-container d-flex gap-2">
                        {rightPageCustomComponent}
                        {pageToolbarButtons
                            ? pageToolbarButtons.map((btn, i) => (
                                  <PageToolbarButton key={i} {...btn} />
                              ))
                            : null}
                    </div>
                </div>
                {/* end::Actions */}
            </div>
        </div>
    );
};
